import { useMemo, useState } from "react";
import type { ProductVariation } from "@/types/productVariations";
import useAppDispatch from "@/hooks/useAppDispatch";

//#region Type
type QuantityViewModelParams = ProductVariation | null;

interface QuantityViewModel {
  quantity: number;
  maxQuantity: number | null;
  handleQuantityChange: (value: number) => void;
}
//#endregion

const useQuantity = (matchedVariation: QuantityViewModelParams): QuantityViewModel => {
  const appDispatch = useAppDispatch();

  const [quantity, setQuantity] = useState(1);

  const maxQuantity: number | null = useMemo(
    () => (matchedVariation?.manage_stock ? matchedVariation?.stock_quantity : null),
    [matchedVariation],
  );

  const handleQuantityChange = (value: number) => {
    if (value <= 0) return;
    if (maxQuantity && value > maxQuantity) {
      appDispatch.pushAlert({
        type: "warning",
        title: `數量不足，庫存僅剩${maxQuantity}件`,
      });
      setQuantity(maxQuantity);
      return;
    }
    setQuantity(value);
  };

  return {
    quantity,
    maxQuantity,
    handleQuantityChange,
  };
};

export default useQuantity;
